import { Injectable } from "@angular/core";
import { AiFeaturesService, IQBoostViewStore } from "@maximizer/ai/data-access";
import { isNullOrEmpty } from "@maximizer/shared/util";

@Injectable()
export class IqboostRecentUserPrompts {

  private readonly MAX_RECENT_USER_PROMPTS = 5;

  constructor(
    private readonly aiFeatures: AiFeaturesService,
    private readonly store: IQBoostViewStore,
  ) {}

  getRecentUserPrompts(): string[] {
    return this.store.dataProcessingFeatureGroup().user.recentUserPrompts ?? [];
  }

  pushUserPrompt(prompt: string): void {
    if (isNullOrEmpty(prompt?.trim())) {
      return;
    }

    const recentUserPrompts = [
      ...this.getRecentUserPrompts().filter((recentPrompt) => recentPrompt.trim() !== prompt.trim()),
    ];

    recentUserPrompts.unshift(prompt);

    if (recentUserPrompts.length > this.MAX_RECENT_USER_PROMPTS) {
      recentUserPrompts.length = this.MAX_RECENT_USER_PROMPTS;
    }

    const group = this.store.dataProcessingFeatureGroup();
    this.store.setDataProcessingFeatureGroup({ ...group, user: { ...group.user, recentUserPrompts } });
    this.aiFeatures.updateUserIqBoostRecord({ recentUserPrompts }).subscribe();
  }
}
